import React, { createContext, useEffect, useRef, useState } from "react";
import useLocalStorage from "use-local-storage";
// import Pusher from 'pusher-js'
// import "dotenv/config";
// import Realm from "realm";
// import * as Realm from "realm-web";
import io from "socket.io-client"
// import { MongoClient } from 'mongodb';
export let context = createContext();

function Context({ children }) {
  let fetchUsers = async () => {
    let fetching = await fetch("https://b-a-backend.onrender.com/getAllUsers");
    let json = await fetching.json();
    return json;
  };
  let [users, setUsers] = useState([]);
  let [signinValue, setSigninValue] = useLocalStorage("signedin", {
    email: "",
    password: "",
  });
  let [changeValueSignin, setChangeValueSignin] = useLocalStorage(
    "ValueSignin",
    {
      email: "",
      password: "",
    }
  );
  let [isSigninToSpeak, setIsSigninToSpeak] = useState(false);
  let [isSigninOutSpeak, setIsSigninOutSpeak] = useState(false);

  let fetchingProducts = async () => {
    let fetching = await fetch("https://b-a-backend.onrender.com/getProducts");
    let json = await fetching.json();
    return json;
  };
  let [products, setProducts] = useState([]);

  let fetchingFreelance = async () => {
    let fetching = await fetch("https://b-a-backend.onrender.com/getFreelance");
    let json = await fetching.json();
    return json;
  };
  let [freelanceMeals, setFreelanceMeals] = useState([]);
  let [showReview, setShowReview] = useState(false);

  let [isLoadingUsers, setIsLoadingUsers] = useState(false);
  let [isLoadingProducts, setIsLoadingProducts] = useState(false);
  let [isLoadingFreelance, setIsLoadingFreelance] = useState(false);

  let [allChat, setAllChat] = useState([]);
  let [selectedUserToChat, setSelectedUserToChat] = useState();
  // let [isSignedIn, setIsSignedIn] = useState(false)
  let [isSignedIn, setIsSignedIn] = useLocalStorage("isSignedIn", false);
  let [openRegister, setOpenRegister] = useState(false);

  let scrollIntoViewRef = useRef(null);

  useEffect(() => {
    setIsLoadingUsers(true);
    setIsLoadingProducts(true);
    setIsLoadingFreelance(true);

    fetchUsers()
      .then((result) => setUsers(result))
      .then(() => setIsLoadingUsers(false));
    fetchingProducts()
      .then((result) => setProducts(result))
      .then(() => setIsLoadingProducts(false));
    fetchingFreelance()
      .then((result) => setFreelanceMeals(result))
      .then(() => setIsLoadingFreelance(false));
  }, []);

  // let url = "https://b-a-backend.onrender.com/getAllUsers"
  // useEffect(() => {
  //   const subscription = users.subscribe(newData => {
  //     setUsers(newData);
  //   });

  //   return () => {
  //     subscription.unsubscribe();
  //   };
  // },[])
  //! https://b-a-backend.onrender.com

  // const ChatSchema = {
  //   name: "chats",
  //   properties: {
  //     text: "string",
  //     from: "string",
  //     sender: "string",
  //   },
  // };
  // const chatRealm = new Realm.App({ id: "application-0-jkxrb" }); // This useEffect hook will run only once when the page is loaded
  // const realm = app.currentUser.realm;

  // const Chat = db('b-a').collection('chats');
  // console.log("🚀 ~ file: Context.jsx:104 ~ Context ~ Chat", Chat)
 
 

  // useEffect(() => {
  //   let pusher = new Pusher("f53671d3665007b93cb0", {
  //     cluster: 'eu'
  //   });

  //   var channel = pusher.subscribe('updateUsers');
  //   channel.bind('inserted', (data) => {
  //     console.log("🚀 ~ file: Context.jsx:34 ~ channel.bind ~ data", data)
  //     // alert(JSON.stringify(data));
  //     setAllChat([...allChat, data])
  //   });
  //   return () => {
  //     channel.unbind_all();
  //     channel.unsubscribe()
  //   }
  // },[allChat])

  // useEffect(() => {
  //   fetchUsers().then((result)=>setUsers(result))
  // }, [selectedUserToChat])

  useEffect(() => {
    fetchUsers().then((result) => setUsers(result));
    scrollIntoViewRef?.current?.scrollIntoView({ behavior: "smooth" });
  }, [allChat]);

  return (
    <context.Provider
      value={{
        users,
        setUsers,
        signinValue,
        setSigninValue,
        fetchingProducts,
        products,
        setProducts,
        fetchUsers,
        setUsers,
        allChat,
        setAllChat,
        selectedUserToChat,
        setSelectedUserToChat,
        isSignedIn,
        setIsSignedIn,
        openRegister,
        setOpenRegister,
        fetchingFreelance,
        freelanceMeals,
        setFreelanceMeals,
        showReview,
        setShowReview,
        scrollIntoViewRef,
        changeValueSignin,
        setChangeValueSignin,
        isSigninToSpeak,
        setIsSigninToSpeak,
        isSigninOutSpeak,
        setIsSigninOutSpeak,
        isLoadingUsers,
        isLoadingProducts,
        isLoadingFreelance,
      }}
    >
      {children}
    </context.Provider>
  );
}

export default Context;
